module.exports = __webpack_public_path__ + "static/media/solia_valentine.0823a252.png";